<script>
	import { uiText } from "../lib/uiText.js";
	import { createEventDispatcher } from "svelte";
	const dispatch = createEventDispatcher();
	export let lang = "en";
	let ui = uiText(lang);
	$: lang, (ui = uiText(lang));
	export let pastAnswers = [];
	export let riddle;
	// console.log(riddle);
	let progbar = riddle.progbar;
	let type = riddle.type || "single";
	let answers = riddle.answers;
	let input = "";
	let isBonus = false;
	let wrongAnswers = [];

	const inActive = [];
	const inPast = [];

	let pastAnswerKeys = Object.keys(pastAnswers);
	let answerKeys = Object.values(answers);
	for (let i = 0; i < answers.length; i++) {
		let singAnw;
		if (typeof answerKeys[i] === "object") {
			singAnw = Object.values(answerKeys[i])[0];
			// console.log(Object.values(answerKeys[i])[0]);
		} else {
			singAnw = answerKeys[i];
			// console.log(answerKeys[i]);
		}
		inPast[i] = pastAnswerKeys.some((el) => singAnw.toLowerCase().includes(el));
	}

	// export let prog
	//$: input,
	//console.log('Single: ' + input.toLowerCase().includes(answers[0])), //сингъл
	//console.log('Multiple: ' + answers.some((el) => input.toLowerCase().includes(el))); //мултипъл

	//
	function checkAnswer() {
		if (input == "" || input.replace(/\s/g, "") == "") {
			console.warn("don't try empty answers, man!");
			return;
		}
		switch (
			type // single <> multiple <> mc (multiple correct) <> mc-multiple || single <> multiple for a start
		) {
			// SASP SAMP MASP MAMP single Answer multiple Possibilities
			case "single":
				if (input.toLowerCase().includes(answers[0])) {
					dispatch("message", {
						msg_content: ui.game.riddle.single_message,
						msg_type: "info",
						msg_action: ui.game.riddle.single_action,
					});
					if (riddle.isBonus) {
						isBonus = true;
					} else {
						isBonus = false;
					}
					dispatch("solve", {
						address: riddle.address,
						wrongAnswers: wrongAnswers,
						// ^ this could become redundant
						isBonus: isBonus,
					});
				} else {
					dispatch("message", {
						msg_content: ui.game.riddle.wrong_message,
						msg_type: "error",
						msg_action: ui.game.riddle.wrong_action,
					});
					wrongAnswers.push(input);
					// ^ this could become redundant
					dispatch("wrongAnswer", {
						//wrongAnswer
						// address: riddle.address,
						wrongAnswer: wrongAnswers[wrongAnswers.length - 1],
						// isBonus: isBonus,
					});
				}
				break;

			case "multiple":
				if (answers.some((el) => input.toLowerCase().includes(el))) {
					dispatch("message", {
						msg_content: ui.game.riddle.single_message,
						msg_type: "info",
						msg_action: ui.game.riddle.single_action,
					});
					if (riddle.isBonus) {
						isBonus = true;
					} else {
						isBonus = false;
					}
					dispatch("solve", {
						address: riddle.address,
						wrongAnswers: wrongAnswers,
						isBonus: isBonus,
					});
					// dispatch('solve', {
					//     address: riddle.address,
					//     wrongAnswers: wrongAnswers,
					// });
				} else {
					dispatch("message", {
						msg_content: ui.game.riddle.multiple_wrong_message,
						msg_type: "error",
						msg_action: ui.game.riddle.multiple_wrong_action,
					});
					wrongAnswers.push(input);
					dispatch("wrongAnswer", {
						//wrongAnswer
						// address: riddle.address,
						wrongAnswer: wrongAnswers[wrongAnswers.length - 1],
						// isBonus: isBonus,
					});
				}
				break;

			case "mc": //multiple correct
				if (answers.some((el) => input.toLowerCase().includes(el))) {
					if (
						Object.keys(pastAnswers).some((el) =>
							input.toLowerCase().includes(el)
						)
					) {
						dispatch("message", {
							msg_content: ui.game.riddle.multiple_repeat_message,
							msg_type: "error",
							msg_action: ui.game.riddle.multiple_repeat_action,
						});
					} else {
						dispatch("partialSolve", { [input]: true });
					}
				} else {
					dispatch("message", {
						msg_content: ui.game.riddle.wrong_message,
						msg_type: "error",
						msg_action: ui.game.riddle.wrong_action,
					});
					wrongAnswers.push(input);
					dispatch("wrongAnswer", {
						//wrongAnswer
						// address: riddle.address,
						wrongAnswer: wrongAnswers[wrongAnswers.length - 1],
						// isBonus: isBonus,
					});
				}

				break;

			case "mc-multiple":
				let mc_multiple = answers;

				for (let i = 0; i < mc_multiple.length; i++) {
					if (typeof mc_multiple[i] === "object") {
						inActive[i] = Object.values(mc_multiple[i]).some((el) =>
							input.toLowerCase().includes(el)
						);
					} else {
						inActive[i] = input.toLowerCase().includes(mc_multiple[i]);
					}
				}
				checkMCMultiple(inActive);

				break;

			default:
				alert(
					"How?! You should not be seeing this... Well, looks like one of the elves messed up... Please report to Santa..um..I mean Obelisk at obelisk [at] vutreshenglas.com. Thanks!"
				);
		}
	}

	function checkMCMultiple(data) {
		let index = data.indexOf(true);

		if (index >= 0) {
			if (!inPast[index]) {
				dispatch("partialSolveType2", { inActive });
			} else {
				dispatch("message", {
					msg_content: ui.game.riddle.multiple_repeat_message,
					msg_type: "error",
					msg_action: ui.game.riddle.multiple_repeat_action,
				});
			}
		} else {
			dispatch("message", {
				msg_content: ui.game.riddle.wrong_message,
				msg_type: "error",
				msg_action: ui.game.riddle.wrong_action,
			});
			wrongAnswers.push(input);
			dispatch("wrongAnswer", {
				//wrongAnswer
				// address: riddle.address,
				wrongAnswer: wrongAnswers[wrongAnswers.length - 1],
				// isBonus: isBonus,
			});
		}
	}

	const handleEnter = (e) => {
		if (e.key === "Enter" || e.keyCode === 13) {
			checkAnswer();
		}
	};
</script>

<div class="input-row">
	<input
		class="grow"
		type="text"
		name="field"
		id="field"
		placeholder="_"
		bind:value={input}
		on:keyup={handleEnter}
	/>
	<button id="trigger" on:click={checkAnswer}>{ui.game.aside.button}</button>
</div>

{#if progbar}
	<ul id="progress">
		{#if type == "mc"}
			{#each riddle.answers as answer, i}
				{#if Object.keys(pastAnswers).some((el) => answer
						.toLowerCase()
						.includes(el))}
					<li class="correct" title="Разкрит отговор">
						<i class="fa-solid fa-check" />
					</li>
				{:else}
					<li style="order:2" title="Неразкрит отговор">
						<i class="fa-solid fa-question" />
					</li>
				{/if}
			{/each}
		{/if}
		{#if type == "mc-multiple"}
			{#each riddle.answers as answer, i}
				{#if typeof answer === "object"}
					{#if inPast[i]}
						<li class="correct" title="Разкрит отговор">
							<i class="fa-solid fa-check" />
						</li>
					{:else}
						<li style="order:2" title="Неразкрит отговор">
							<i class="fa-solid fa-question" />
						</li>
					{/if}
				{:else if Object.keys(pastAnswers).some((el) => answer
						.toLowerCase()
						.includes(el))}
					<li class="correct" title="Разкрит отговор">
						<i class="fa-solid fa-check" />
					</li>
				{:else}
					<li style="order:2" title="Неразкрит отговор">
						<i class="fa-solid fa-question" />
					</li>
				{/if}
			{/each}
		{/if}
	</ul>
{/if}

<style>
	#progress {
		display: flex;
		flex-wrap: wrap;
		width: 100%;
		padding: 10px;
		gap: 10px;
	}
	#progress li {
		/* margin: 10px; */
		/* height: 16px; */

		border: 2px solid white;
		flex: 1;
		box-shadow: #093a86 5px 5px 0;
		text-align: center;
	}

	#progress li.correct {
		color: white;
		border: 2px solid green;
		background-color: green;
	}
	#progress li i {
		line-height: inherit;
	}

	.input-row {
		display: grid;
		grid-template-columns: 1fr max-content;
		/* width: min(800px, 100%); */
	}
	@media screen and (max-width: 480px) {
		.input-row {
			grid-template-columns: auto;
		}
	}
</style>
